/* eslint-disable prettier/prettier */

import { apiService } from './api.service';

export interface ProgramOverviewFilters {
	page?: number;
	limit?: number;
	status?: string;
	search?: string;
}

export interface ProgramOverviewRow {
	id: string;
	createdby: string;
	programownerid: string | null;

	title: string;
	status: string;
	thumbnail: string | null;
	createdat: string;

	coachcount: number;
	learnercount: number;
	resourcecount: number;

	sessions: {
		done: number;
		total: number;
		label: string;
	};

	masterclasses: {
		done: number;
		total: number;
		label: string;
	};

	completionrate: number | null;
}

export interface ProgramsOverviewResponse {
	programs: ProgramOverviewRow[];
	total: number;
	page: number;
	limit: number;
}

class ProgramOverviewService {
	private readonly baseUrl = '/schedule/admin/programs-overview';

	async getProgramsOverview(
		filters?: ProgramOverviewFilters
	): Promise<ProgramsOverviewResponse> {
		try {
			const response = await apiService.get<ProgramsOverviewResponse>(
				this.baseUrl,
				filters
			);

			if (!response.success) {
				throw new Error(
					response.message || 'Failed to fetch programs overview'
				);
			}

			return response.data;
		} catch (error: any) {
			console.error('Error fetching programs overview:', error);

			throw new Error(
				error?.response?.data?.message ||
					error?.message ||
					'Failed to fetch programs overview'
			);
		}
	}
}

export const programOverviewService = new ProgramOverviewService();
